import React from 'react';
import { PageHeader, Placeholder } from '../_components/common';

const PlatformUsage = () => (
  <div className="max-w-5xl">
    <PageHeader
      title="Usage & Billing"
      subtitle="Per-consumer call volume, rows returned, and metered charges."
    />
    <Placeholder
      icon="BarChart3"
      title="Usage & billing isn't available yet"
      text="This tab will show per-consumer call counts, rows returned, and computed amounts once the backend usage-rollup endpoints are built. The API currently returns not_implemented, so no data is shown."
    />
  </div>
);

export default PlatformUsage;
